export default "__VITE_ASSET__DEi3Xdd0__"